import type { Schema } from '@/shared/api/contract';

/**
 * The vocabulary of the document archive (contract v10.5), shared by the archive screen
 * and the administration panel: what each kind is called and how a number of days reads.
 */
export type DocumentKind = Schema<'DocumentKind'>;

export const KIND_LABELS: Record<DocumentKind, string> = {
  factura_proveedor: 'Factura de proveedor',
  albaran: 'Albarán',
  pedido_cliente: 'Pedido de cliente',
  solicitud: 'Solicitud',
  oferta_proveedor: 'Oferta de proveedor',
  presupuesto_emitido: 'Presupuesto emitido',
  aviso_bancario: 'Aviso bancario',
  otro: 'Otro',
};

export const KINDS: readonly DocumentKind[] = Object.keys(KIND_LABELS) as DocumentKind[];

export function kindLabel(kind: string): string {
  return (KIND_LABELS as Record<string, string>)[kind] ?? kind;
}

export const MONTH_NAMES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
] as const;

export function monthLabel(year: number, month: number): string {
  return `${MONTH_NAMES[month - 1] ?? month} ${year}`;
}

/** Days as «6 años», «90 días»: what a person reads on the policy screen. */
export function daysLabel(days: number): string {
  if (days >= 365 && (days % 365 === 0 || days % 365 <= 2)) {
    const years = Math.floor(days / 365);
    return years === 1 ? '1 año' : `${years} años`;
  }
  return days === 1 ? '1 día' : `${days} días`;
}
